module.exports = __webpack_public_path__ + "img/italy.b1046d15.svg";